"use client";
import ReactStars from "react-stars";

const Stars = (props: any) => {
  return (
    <ReactStars
      value={props?.value}
      onChange={props.onChange}
      size={props.size || 24}
      color2={"#eab308"}
      edit={props.edit }
    />
  );
};

export default Stars;
